<div class="login-screen">
    <div class="row w-100 m-0 align-login-card">
        <!-- Left Column -->
        <div class="offset-lg-1 col-xl-4 col-lg-6">
            <div class="card">
                <div class="card-body">
                    <img src="assets/images/logo.svg" class="m-auto d-table" />
                    <h2 class="mt-4 mb-3">Forgot Password</h2>
                    <p>Enter the email address associated with your account.</p>

                    <form *ngIf="forgotPassWordForm" [formGroup]="forgotPassWordForm" (ngSubmit)="submitForgotPassForm()" novalidate>
                        <div class="row gy-3">
                            <!-- Email Field -->
                            <div class="col-lg-12 mb-3">
                                <label class="text-start">Email Address <span class="text-danger">*</span></label>
                                <mat-form-field class="w-100">
                                    <input type="email" matInput formControlName="UserEmail" (input)="trimInput($event)" maxlength="100" placeholder="Enter your email" />

                                </mat-form-field>
                                <mat-error *ngIf="submitted && loginFormControls['UserEmail'].errors?.['required']">
                                    {{ errorConstants.EmailRequired }}
                                </mat-error>
                                <mat-error *ngIf="submitted && loginFormControls['UserEmail'].errors?.['pattern']">
                                    {{ errorConstants.EmailNotValid }}
                                </mat-error>
                            </div>

                            <!-- Submit Button -->
                            <div class="col-lg-12">
                                <app-recaptcha-widget #recaptchaWidget
                                    (resolved)="onCaptchaResolved()"
                                    (expired)="onCaptchaExpired()"></app-recaptcha-widget>
                            </div>
                            <div class="col-lg-12">
                                <button matButton="filled" type="submit" class="w-100 btn-primary"
                                    [disabled]="captchaService.isEnabled() && !isCaptchaVerified">
                                    Send
                                </button>
                            </div>
                        </div>
                    </form>

                    <!-- Back to Login -->
                    <div class="text-center mt-3">
                        <a class="fs-6 text-dark" (click)="backToLogin()">
                            <i class="fa-solid fa-arrow-left me-2"></i><b>Back To Login</b>
                        </a>
                    </div>

                    <!-- Footer -->
                    <div class="card-footer border-0 mt-5">
                        <p class="m-0">
                            © {{year}} ALL RIGHTS RESERVED.
                            <a href="https://www.vaultx.com/" class="fw-medium text-primary" target="_blank">
                                <span>Collect</span><span class="text-dark">X</span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Column (Visuals) -->
        <div class="col-xl-7">
        </div>
    </div>
</div>